<template>
    <div class="property-list list-group list-group-flush">
        <a
        :href="buildLink(item)"
        target="_blank"
        class="d-flex list-group-item list-group-item-action flex-row property-item border-0 mb-3 rounded"
        :class="{ 'highlighted': highlighted }"
        v-for="(item, itemIndex) in items"
        @mouseover="() => hoverItem(item, itemIndex)"
        @mouseleave="leaveItem(item)"
        :key="'property_item_' + item.id"
        @click="trackProductClick(item)">

            <!-- Images -->
            <div class="images carousel slide" data-pause="false" data-interval="1000" :id="'carousel_' + itemIndex">
                <span class="ratings-badge" v-if="item.ratings" :class="{ highlight: item.ratings.overall >= 4.5 }">
                    <i class="fa fa-star star-1" v-if="item.ratings.overall >= 4.5"></i>
                    <i class="fa fa-star star-2" v-if="item.ratings.overall >= 4.5"></i>
                    <i class="fa fa-star star-3" v-if="item.ratings.overall >= 4.5"></i>

                    <span class="amount">
                        {{ item.ratings.overall | formatRatings }}
                    </span>
                </span>

                <!-- <ol class="carousel-indicators" v-if="item.images.length > 0">
                    <li :data-target="'carousel_' + itemIndex" data-slide-to="0" class="active"></li>
                    <li :data-target="'carousel_' + itemIndex" :data-slide-to="imageIndex + 1" v-for="(image, imageIndex) in item.images.slice(0, 5)"></li>
                </ol> -->

                <div class="carousel-inner">
                    <!-- Cover image -->
                    <div class="carousel-item active">
                        <img :src="'https://d36xws8ymuqmas.cloudfront.net/' + item.image + '?width=' + (imageWidth * 2) + '&height=480'" :alt="item.name" />
                    </div>

                    <div class="carousel-item" v-for="(image, imageIndex) in item.images" :key="'property_image_' + item.id + '_' + imageIndex">
                        <img :src="'https://d36xws8ymuqmas.cloudfront.net/' + image.image + '?width=480&height=480'" :alt="image.description">
                    </div>

                    <div class="carousel-item more-images-link">
                        <i class="far fa-images"></i>
                        <span>
                            {{ 'search.propertyList.showAllImages' | trans({ count: item.images_count }) }}
                        </span>
                    </div>
                </div>

                <!-- Controls -->
                <button type="button" class="btn carousel-control prev" @click.prevent="prevImage(itemIndex)">
                    <i class="far fa-chevron-left"></i>
                </button>
                <button type="button" class="btn carousel-control next" @click.prevent="nextImage(itemIndex)">
                    <i class="far fa-chevron-right"></i>
                </button>
            </div>

            <div class="inner-content">

                <div class="d-inline-flex flex-column flex-grow-1">
                    <!-- Type -->
                    <span class="type-badge" v-if="item.type">
                        {{ item.type.name }}

                        <!-- Stars -->
                        <span class="stars" v-if="item.stars && item.stars > 0">
                            <i class="fa fa-star" v-for="i in item.stars / 1"></i>
                            <i class="fa fa-star-half" v-for="i in item.stars % 1 > 0"></i>
                        </span>
                    </span>

                    <!-- Name -->
                    <span class="name">
                        {{ item.name }}
                    </span>

                    <!-- Address -->
                    <span class="address">
                        {{ item.city }}, {{ item.country }}

                        <!-- Distance to center -->
                        <small class="text-muted" v-if="item.distance_to_center">
                            &bull;
                            {{ 'search.cityCenter' | trans }}:
                            {{ displayDistance(item.distance_to_center) }}
                        </small>
                    </span>

                    <!-- Ratings -->
                    <span class="ratings" v-if="item.ratings" data-toggle="popover" data-content="Test" data-trigger="hover">
                        <span class="overall">
                            {{ ratingsText(item.ratings.overall) }}
                        </span>

                        <span class="count">
                            {{ item.ratings.count }}
                            {{ 'search.propertyList.ratings' | trans }}
                        </span>
                    </span>

                    <!-- Cancellation -->
                    <span class="refundable"
                    v-if="item.from_price && item.from_price.is_refundable && item.from_price.refundable_type === 'full'"
                    v-popover="{ name: 'cancellationInfo' + item.id }">
                        <i class="wa-icon-check-circle mr-1"></i>
                        {{ 'checkout.summary.refundable' | trans }}

                        <!-- Cancellation popover -->
                        <popover :name="'cancellationInfo' + item.id" :width="300" event="hover">
                            {{ 'checkout.summary.refundableUntil' | trans({ date: $moment(item.from_price.refundable_until).format('DD.MM.YYYY'), time: $moment(item.from_price.refundable_until).format('HH:mm') }) }}
                        </popover>
                    </span>
                    <!-- <span class="non-refundable" v-if="item.from_price && ! item.from_price.is_refundable">
                        <i class="wa-icon-money-exchange mr-1"></i>
                        Nicht stornierbar
                    </span> -->
                </div>

                <div class="right-details">
                    <!-- Bookmark -->
                    <button type="button" class="btn btn-link btn-lg p-2 btn-bookmark" :class="{ active: item.is_bookmarked }" @click.prevent="toggleBookmark(item)">
                        <i :class="{ 'wa-icon-heart': ! item.is_bookmarked, 'wa-icon-heart-filled': item.is_bookmarked }"></i>
                    </button>

                    <div class="d-flex flex-column align-items-end">
                        <!-- Price -->
                        <div class="price" v-if="item.from_price">
                            <!-- Fees -->
                            <span class="fees" v-if="item.from_price && item.from_price.fees.length > 0" v-popover="{ name: 'fees_' + item.id }">
                                <i class="far fa-info-circle mr-2 text-muted"></i>

                                <!-- Popover -->
                                <popover :name="'fees_' + item.id" :width="200" event="hover">
                                    <span class="d-block" v-for="(fee, feeIndex) in item.from_price.fees" :key="'fees_' + item.id + '_' + feeIndex">
                                        {{ 'search.fees.calculationTypes.exclusive_short' | trans }}
                                        {{ fee.total | formatPriceRounded }}
                                        &euro;
                                        {{ 'search.fees.types.' + fee.type | trans }}
                                        <!-- {{ 'search.fees.scopes.' + fee.scope | trans }} -->
                                        <!-- {{ 'search.fees.frequencies.' + fee.frequency | trans }} -->
                                    </span>
                                </popover>
                            </span>

                            <!-- Currency -->
                            <span class="currency" v-if="item.from_price.currency === 'EUR'">
                                &euro;
                            </span>

                            <!-- Total -->
                            <span class="total">
                                {{ item.from_price.total | formatPrice }}
                            </span>
                        </div>

                        <!-- Total unit -->
                        <small class="total-unit" v-if="item.from_price">
                            {{ 'search.propertyList.totalPrice' | trans }}
                        </small>

                        <!-- Strikethrough -->
                        <small class="total-unit" v-if="item.from_price && item.from_price.strikethrough_description">
                            {{ item.from_price.strikethrough_description }}
                        </small>
                    </div>

                    <!-- sale scenario: package -->
                    <span class="sale-scenario-badge sale-scenario-badge--package d-none d-md-block" v-if="item.from_price && item.from_price.sale_scenarios && item.from_price.sale_scenarios.indexOf('package') !== -1" v-popover="{ name: 'package_info_' + item.id }">
                        <i class="fa fa-cubes mr-1"></i>
                        {{ 'search.packageInfoLabel' | trans }}

                        <!-- Popover -->
                        <popover :name="'package_info_' + item.id" :width="200" event="hover">
                            {{ 'search.packageInfo' | trans }}
                        </popover>
                    </span>

                    <!-- sale scenario: member -->
                    <span class="sale-scenario-badge sale-scenario-badge--member d-none d-md-block" v-if="item.from_price && item.from_price.sale_scenarios && item.from_price.sale_scenarios.indexOf('member') !== -1 && filters && filters.is_member === true && item.from_price.strikethrough_description" v-popover="{ name: 'member_info_' + item.id }">
                        <i class="fa fa-badge-percent mr-1"></i>
                        {{ 'search.memberInfoLabel' | trans }}

                        <!-- Popover -->
                        <popover :name="'member_info_' + item.id" :width="200" event="hover">
                            {{ 'search.memberInfo' | trans }}
                        </popover>
                    </span>

                    <!-- Profit -->
                    <span class="profit-badge d-none d-md-block" v-if="item.from_price && item.from_price.profit" v-popover="{ name: 'profit_' + item.id }">
                        <i class="fa fa-coins mr-1"></i>
                        {{ item.from_price.profit | formatPrice }}
                        &euro;
                        {{ 'search.profit' | trans }}

                        <!-- Popover -->
                        <popover :name="'profit_' + item.id" :width="200" event="hover" v-if="item.from_price && item.from_price.profit">
                            {{ 'search.profitInfo' | trans({ profit: item.from_price.profit }) }}
                        </popover>
                    </span>

                    <!-- Not available info -->
                    <span class="text-right my-2 text-danger" v-if="! item.from_price && isTravelPeriod">
                        <i class="fas fa-info-circle mr-1"></i>
                        {{ 'search.propertyList.notAvailableInfo' | trans }}
                    </span>

                    <!-- No price info -->
                    <span class="text-right my-2 text-muted" v-if="! item.from_price && ! isTravelPeriod">
                        <i class="fas fa-info-circle mr-1"></i>
                        {{ 'search.propertyList.noPriceInfo' | trans }}
                    </span>

                    <!-- Call to action -->
                    <button type="button" class="btn btn-outline-default align-items-end call-to-action d-none d-md-block">
                        {{ 'search.propertyList.goToHotel' | trans }}
                    </button>
                </div>
            </div>
        </a>
    </div>
</template>

<script>
    export default {
        props: ['items', 'isTravelPeriod', 'travelPeriod', 'searchToken', 'filters', 'highlighted'],
        data() {
            return {
                imageWidth: 200,
            }
        },
        mounted() {
            if ($(window).width() >= 1200) {
                this.imageWidth = 240
            } else if ($(window).width() < 576) {
                this.imageWidth = 100
            }
        },
        computed: {},
        methods: {
            hoverItem(item, index) {
                this.$emit('centerProperty', item)

                // Start carousel
                this.startCarousel('carousel_' + index)
            },
            leaveItem(item) {
                this.stopCarousel()
            },
            toggleBookmark(item) {
                this.$emit('toggleBookmarkProperty', item)
            },
            startCarousel(id) {
                $('#' + id).carousel('cycle');
            },
            stopCarousel() {
                $('div.carousel').carousel('pause');
            },
            nextImage(index) {
                $('div.carousel').carousel('pause');
                $('#carousel_' + index).carousel('next');
            },
            prevImage(index) {
                $('div.carousel').carousel('pause');
                $('#carousel_' + index).carousel('prev');
            },
            ratingsText(rating) {
                if (rating >= 3.0 && rating < 4.0) {
                    return this.$window.Lang.get('search.ratings.good')
                } else if (rating >= 4.0 && rating < 4.3) {
                    return this.$window.Lang.get('search.ratings.veryGood')
                } else if (rating >= 4.3 && rating < 4.5) {
                    return this.$window.Lang.get('search.ratings.outstanding')
                } else if (rating >= 4.5 && rating < 4.7) {
                    return this.$window.Lang.get('search.ratings.wonderful')
                } else if (rating >= 4.7) {
                    return this.$window.Lang.get('search.ratings.extraordinary')
                }

                return null;
            },
            buildLink(property) {
                let params = []

                // Token
                if (this.searchToken) {
                    params.push('search_token=' + this.searchToken)
                }

                // Travel period
                if (this.travelPeriod && this.travelPeriod.from && this.travelPeriod.to) {
                    params.push('date_from=' + this.travelPeriod.from.format('YYYY-MM-DD'))
                    params.push('date_to=' + this.travelPeriod.to.format('YYYY-MM-DD'))
                }

                // Room code
                if (property.from_price && property.from_price.room_code) {
                    params.push('room_code=' + property.from_price.room_code)
                }

                // Persons
                if (this.$root.$refs.search) {
                    const persons = this.$root.$refs.search.persons
                    params.push('adults=' + this.$lodash.sumBy(persons.filter((person) => person.type === 'adult'), 'amount'))

                    if (persons.filter((person) => person.type === 'child').length > 0) {
                        params.push('children=' + persons.filter((person) => person.type === 'child').map((child) => child.birthdate).join(','))
                    }
                }

                // Filters
                const filters = []
                filters.push(this.$root.$refs.search.filters.is_refundable ? 'refundable' : 'none_refundable')
                if (this.$root.$refs.search.filters.is_package) {
                    filters.push('package')
                }
                if (this.$root.$refs.search.filters.is_member) {
                    filters.push('member')
                }
                params.push('filters=' + filters.join(','))

                return property.url + (params.length > 0 ? '?' + params.join('&') : '')
            },

            displayDistance(distanceInMeters) {
                if (distanceInMeters < 1000) {
                    return distanceInMeters + ' m'
                } else {
                    return Math.round((distanceInMeters / 1000) * 10) / 10 + ' km'
                }
            },

            trackProductClick(item) {
                // Clear previous ecommerce object
                this.$window.dataLayer.push({
                    ecommerce: null,
                })

                // Push updated data
                this.$window.dataLayer.push({
                    'event': 'eeProductClick',
                    'ecommerce': {
                        'currencyCode': 'EUR',
                        'click': {
                            'actionField': {'list': 'Search Results'},

                            'products': [{
                                'id': 'watado-trips_' + item.id,
                                'name': item.name,
                                'price': item.from_price ? item.from_price.total : null,
                                'revenue': item.from_price ? item.from_price.total : null,
                                'tax': 0,
                                'shipping': 0,
                                'brand': 'watado-trips',
                                'category': (item.type ? item.type.name : 'Hotel') + ' - ' + item.city + ', ' + item.country,
                                'quantity': 1,
                                'list': 'Search Results',
                                'affiliation': 'watado-trips',
                            }],
                        },
                    }
                })
            },
        },
        watch: {
            items() {
                this.$emit('centerProperty', null)
            },
        }
    }
</script>
